import { AptiveIcon } from "./Icon";
export default AptiveIcon;
